import React from 'react'
import { animationData } from '../../assets/animations/icons8-spinner.json'
import Lottie from 'react-lottie'
import './RedirectProgress.scss'

export const RedirectProgress: React.FC = () => {
  return (
    <div className='auth-container'>
      <div className='auth-popup-container'>
        <div className='auth-popup-inner'>
          <div className='redirect-header' />
          <h2 className='auth-popup-header'>Redirecting in a couple of seconds</h2>
          <RedirectSpinner />
        </div>
      </div>
    </div>
  )
}

const RedirectSpinner: React.FC = () => {
  const options = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return <Lottie options={options} width={40} height={40} isClickToPauseDisabled={true} />
}
